import React from 'react';
import {
  Col,
  ControlLabel,
  Dropdown,
  FormGroup,
  Row,
  MenuItem,
} from 'react-bootstrap';
import PropTypes from 'prop-types';
import { upperCase } from 'lodash/fp';
import { FeeCategory } from '@upstart/harmony/lib/constants';
import NumberInput from './NumberInput';
import './Worksheet.scss';

function FeeRow(props) {
  const {
    name,
    label,
    value,
    category,
    onValueChange,
    onCategoryChange,
    onFeeDelete,
  } = props;
  const feeCategories = Object.entries(FeeCategory).map(([, f]) => f);
  return (
    <Row>
      <FormGroup controlId={name} className="formGroup form-inline form-group">
        <Col md={3}>
          <ControlLabel className="summary-row-label">{label}</ControlLabel>
        </Col>
        <Col md={3}>
          <NumberInput
            name={name}
            value={value}
            precision={2}
            onChange={onValueChange}
          />
        </Col>
        <Col md={3} className="text-right">
          <Dropdown
            className="dropdown dropdown-trigger"
            id="user-dropdown-basic"
          >
            <Dropdown.Toggle
              className="dropdown-label"
              id="user-dropdown-toggle"
            >
              {upperCase(category)}
            </Dropdown.Toggle>
            <Dropdown.Menu>
              {feeCategories.map(f => (
                <MenuItem key={f} onSelect={() => onCategoryChange(f)}>
                  {upperCase(f)}
                </MenuItem>
              ))}
            </Dropdown.Menu>
          </Dropdown>
        </Col>
        <Col md={1} className="text-right">
          <button className="btn" onClick={() => onFeeDelete()}>
            &times;
          </button>
        </Col>
      </FormGroup>
    </Row>
  );
}

FeeRow.propTypes = {
  name: PropTypes.string,
  label: PropTypes.string,
  value: PropTypes.number,
  category: PropTypes.string,
  onValueChange: PropTypes.func,
  onCategoryChange: PropTypes.func,
  onFeeDelete: PropTypes.func,
};

export default FeeRow;
